window.addEventListener("load", function () {
	const updateProductCards = () => {
		//LOGIC FOR PRODUCT CARD VARIANT IMAGE BEHAVIOUR WHEN VARIANTS ARE SPLIT BY PRODUCT
		const relatedImages = document.querySelectorAll(
			".related-product-image img",
		);

		if (relatedImages) {
			relatedImages.forEach(function (img) {
				img.addEventListener("click", function (event) {
					const clickedSrc = event.target.getAttribute("src");

					let parentElement = event.target.closest(".product-card");
					const mainImage = parentElement.querySelector(".product-image img");
					const mainImageContainer =
						parentElement.querySelector(".product-image");

					if (mainImage) {
						mainImage.setAttribute("src", clickedSrc);
					}

					const variantPrice = event.target.dataset.variantPrice;
					const variantCompareAtPrice =
						event.target.dataset.variantCompareAtPrice;
					const priceElement = parentElement.querySelector(
						"[data-product-price-current]",
					);

					// LOGIC TO HANDLE SALES TAG
					let discountTag = parentElement.querySelector(".discount-percentage");
					if (variantCompareAtPrice) {
						let discountRaw =
							((parseFloat(variantCompareAtPrice.replace(/[^0-9.-]+/g, "")) -
								parseFloat(variantPrice.replace(/[^0-9.-]+/g, ""))) /
								parseFloat(variantCompareAtPrice.replace(/[^0-9.-]+/g, ""))) *
							100;
						let formattedDiscount = Math.round(discountRaw);
						if (discountTag) {
							discountTag.innerText = `${formattedDiscount}% OFF`;
						} else {
							let discountContainer = document.createElement("div");
							discountContainer.classList.add("mt-2", "product-tag-container");
							discountContainer.innerHTML = `<div class="flex">
              <div class="discount-percentage bg-red-100 text-red-600 border-white border-[0.8px] border-solid uppercase tracking-[0.16px] text-[10px] font-bold mr-1 my-0 rounded-sm p-[3px]" style="padding: 3px;">${formattedDiscount}% off</div></div>`;
							mainImageContainer.after(discountContainer);
						}
					} else {
						if (discountTag) {
							discountTag.remove();
						}
					}

					let comparePriceWrapper = parentElement.querySelector(
						"[data-product-price-compare-wrapper]",
					);

					if (priceElement) {
						priceElement.textContent = variantPrice;
					}

					if (!comparePriceWrapper) {
						comparePriceWrapper = document.createElement("span");
						comparePriceWrapper.setAttribute(
							"data-product-price-compare-wrapper",
							"",
						);
						comparePriceWrapper.className =
							"product-price line-through text-sm tracking-[0.224px] mr-1";
						const parentDiv = parentElement.querySelector(
							"[data-product-price-wrapper] div",
						);
						parentDiv.insertBefore(comparePriceWrapper, priceElement);
					}

					if (
						parseFloat(variantCompareAtPrice.replace(/[^0-9.-]+/g, "")) >
						parseFloat(variantPrice.replace(/[^0-9.-]+/g, ""))
					) {
						comparePriceWrapper.textContent = variantCompareAtPrice;
						comparePriceWrapper.style.display = "";
					} else {
						comparePriceWrapper.textContent = "";
						comparePriceWrapper.style.display = "none";
					}
					const variantUrl = event.target.dataset.variantUrl;
					const anchorElementPhoto =
						parentElement.querySelector(".product-image a");
					const anchorElementPrice =
						parentElement.querySelector(".product-info a");

					if (anchorElementPhoto && anchorElementPrice) {
						anchorElementPhoto.setAttribute("href", variantUrl);
						anchorElementPrice.setAttribute("href", variantUrl);
					}
				});
			});
		}

		//LOGIC FOR PRODUCT CARD VARIANT IMAGE BEHAVIOUR WHEN EACH PRODUCTS CONTAINS ITS OWN VARIANTS

		const productCards = document.querySelectorAll("[data-product-id]");

		const currentLocation = window.location.href;

		// First forEach for handling discountPercentage
		productCards.forEach((card) => {
			const parentGridItem = card.closest(".grid__item");

			if (parentGridItem) {
				const prevPrice = parseFloat(
					parentGridItem.dataset.compareAtPrice.replace(/[^0-9.-]+/g, ""),
				);
				const currentPrice = parseFloat(
					parentGridItem.dataset.price.replace(/[^0-9.-]+/g, ""),
				);

				const discountPercentage = Math.round(
					((prevPrice - currentPrice) / prevPrice) * 100,
				);
				const discountElement = card.querySelector(".discount-percentage");
				const comparePriceWrapper = card.querySelector(
					"[data-product-price-compare-wrapper]",
				);

				if (
					discountPercentage > 0 &&
					isFinite(discountPercentage) &&
					discountElement
				) {
					discountElement.textContent = `${discountPercentage}% off`;
					discountElement.style.padding = "3px";
				} else if (discountElement) {
					discountElement.classList.add("hidden");
					comparePriceWrapper.classList.add("hidden");
				}
			}
		});

		// Second forEach for handling variantImages configuration
		productCards.forEach((card) => {
			const mainImageLink = card.querySelector(".product-image a");
			const mainImage = card.querySelector("[data-main-image]");
			const variantImages = card.querySelectorAll(".variant-image img");
			function currencyToNumber(currencyString) {
				const cleanedString = currencyString.replace(/[^0-9. ]+/g, "");
				const numbers = parseFloat(cleanedString);
				return numbers;
			}

			variantImages.forEach((image) => {
				image.addEventListener("click", () => {
					const imageUrl = new URL(image.src);
					imageUrl.searchParams.set("nocache", new Date().getTime());
					card.classList.add("loading");

					mainImage.src = imageUrl.href;
					mainImage.onload = () => {
						card.classList.remove("loading");
					};

					let priceWrapper = card.querySelector(".priceWrapper");
					let priceRangeWrapper = card.querySelector(".priceRangeWrapper");

					priceWrapper.classList.remove("hidden");
					if (priceRangeWrapper) {
						priceRangeWrapper.classList.add("hidden");
					}

					mainImageLink.href = image.dataset.variantUrl;

					const variantPrice = image.dataset.variantPrice;
					const compareAtPrice = image.dataset.variantCompareAtPrice;

					const priceElement = card.querySelector(
						"[data-product-price-wrapper] span:last-child",
					);
					priceElement.textContent = variantPrice;

					const discountElement = card.querySelector(".discount-percentage");

					const comparePriceWrapper = card.querySelector(
						"[data-product-price-compare-wrapper]",
					);

					const discountPercentage = Math.round(
						((currencyToNumber(compareAtPrice) -
							currencyToNumber(variantPrice)) /
							currencyToNumber(compareAtPrice)) *
							100,
					);

					if (
						currencyToNumber(compareAtPrice) > currencyToNumber(variantPrice)
					) {
						comparePriceWrapper.textContent = compareAtPrice;
						comparePriceWrapper.classList.remove("hidden");
						discountElement.textContent = `${discountPercentage}% off`;

						discountElement.style.padding = "3px";
						discountElement.classList.remove("hidden");
					} else {
						comparePriceWrapper.textContent = "";
						comparePriceWrapper.classList.add("hidden");
						discountElement.classList.add("hidden");
					}
				});
			});

			// Set the initial price for the displayed variant image

			if (
				!currentLocation.includes("collections") &&
				!currentLocation.includes("search?")
			) {
				const initialVariant = card.querySelector(".variant-image img");
				if (initialVariant) {
					const initialVariantPrice = initialVariant.dataset.variantPrice;
					const initialCompareAtPrice =
						initialVariant.dataset.variantCompareAtPrice;

					const priceElement = card.querySelector(
						"[data-product-price-wrapper] span:last-child",
					);
					priceElement.textContent = initialVariantPrice;

					const comparePriceWrapper = card.querySelector(
						"[data-product-price-compare-wrapper]",
					);

					if (
						currencyToNumber(initialCompareAtPrice) >
						currencyToNumber(initialVariantPrice)
					) {
						comparePriceWrapper.textContent = initialCompareAtPrice;
						comparePriceWrapper.style.display = "";
					} else if (comparePriceWrapper) {
						comparePriceWrapper.textContent = "";
						comparePriceWrapper.style.display = "none";
					}
				}
			}
		});
	};

	updateProductCards();

	// remove global 'margin-bottom' from product carousel section container
	const carouselContainers = document.querySelectorAll(
		".container-product-carousel",
	);
	if (carouselContainers) {
		carouselContainers.forEach((e) => {
			const parent = e.parentElement;
			parent.style.marginBottom = "0";
		});
	}

	const productCardObserver = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.type === "childList") {
				let shouldUpdate = true;

				let node = mutation.target;
				while (node !== null && node !== document) {
					if (node.classList && node.classList.contains("grid__item")) {
						shouldUpdate = false;
						break;
					}
					node = node.parentNode;
				}

				if (shouldUpdate) {
					updateProductCards();
				}
			}
		});
	});

	let productCardCollectionContainer =
		document.querySelector(".product-grid-container") ||
		document.getElementById("ProductGridContainer");

	const productCardObserverConfig = {
		attributes: true,
		childList: true,
		subtree: true,
	};

	if (productCardCollectionContainer) {
    productCardObserver.observe(
      productCardCollectionContainer,
      productCardObserverConfig,
    );
  }
});
